import { useState } from "react";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { IconButton, AppBar, Box, Toolbar, styled, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import i18next from "i18next";
import NavDrawer from "./NavDrawer";
import TransLang from "./TransLang"
import { useTheme } from '@mui/material/styles';
import { Pages } from "../../../constants";
import DarkModeToggle from "../../global/DarkModeToggle";
// import logo from './../../../assets/Logo/logo.png'
function Navbar2({ data }) {
    const theme = useTheme();
    let lng = i18next.language
    const [drawer, setDrawer] = useState(false);
    const StyledLink = styled(NavLink)(({ theme, isActive }) => ({
        textDecoration: "none",
        fontSize: 24,
        textTransform: 'capitalize',
        color: isActive ? theme.palette.nav.hover : theme.palette.nav.link,
        fontWeight: 400,
        lineHeight: '100%',
        position: 'relative',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        borderLeft: '2px solid transparent',
        paddingLeft: '16px',
        '&:not(:last-child)': {
            borderLeft: `2px solid #B7B5B5`,
        },
        '&:hover': {
            color: theme.palette.nav.hover,
            transform: 'translateY(-2px)',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '-4px',
            left: 0,
            width: '100%',
            height: '2px',
            backgroundColor: theme.palette.nav.hover,
            // backgroundColor: 'transparent',
            backgroundImage: `linear-gradient(to right, ${theme.palette.nav.hover}, ${theme.palette.nav.hover})`,
            backgroundSize: '0 2px',
            backgroundRepeat: 'no-repeat',
            // transition: 'background-size 0.3s ease',
            transform: isActive ? 'scaleX(1)' : 'scaleX(0)',
            transformOrigin: 'right',
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
        '&:hover::after': {
            transform: 'scaleX(1)',
            transformOrigin: 'left',
            backgroundImage: `linear-gradient(to right, ${theme.palette.nav.hover}, ${theme.palette.nav.hover})`,
            backgroundSize: '0 2px',
            backgroundRepeat: 'no-repeat',
        },
    }));
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    return (
        <>
            <AppBar position="static" elevation={0} sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                // boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                position: 'sticky',
                top: 0,
                zIndex: 999,
                py:0.5
            }}>
                <Toolbar disableGutters>
                    <Container maxWidth={'90%'} sx={{ width: { md: '90%', xs: '100%' }, m: 'auto' }}>
                        <Box
                            sx={{
                                flexGrow: 1,
                                // marginInlineStart: 1,
                                py:1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'space-between',
                            }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <RouterLink
                                    to="/"
                                    style={{ textDecoration: "none", lineHeight: 1 }}>
                                    <img src={data?.headerLogo} alt="logo" />
                                </RouterLink>
                            </Box>
                            <Box
                                sx={{
                                    display: { md: "flex", xs: "none" },
                                    alignItems: "center",
                                    justifyContent: 'center',
                                    width: '100%',
                                    gap: '2%',
                                    // marginInlineStart: 4
                                }}>
                                {Pages?.map((page, i) => (
                                    <StyledLink
                                        key={i}
                                        to={page.path}
                                        className={'link'}
                                        onClick={() => scrollToTop()}
                                        style={({ isActive }) => ({
                                            color: isActive ? theme.palette.nav.hover : theme.palette.nav.link,
                                        })}
                                    >
                                        {lng === 'ar' ? page.name : page.name_en}
                                    </StyledLink>
                                ))}
                            </Box>
                            <TransLang />
                            <DarkModeToggle />
                        </Box>
                        <Box sx={{ justifyContent: 'space-between', display: 'flex', gap: { md: '65px', xs: 1 }, width: { md: 'fit-content', xs: '100%' }, alignItems: 'center' }} >
                            <Box
                                sx={{
                                    flexGrow: 0,
                                    display: { md: "none", xs: "flex" },
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: 'center'
                                }}>
                                <RouterLink
                                    to="/"
                                    style={{
                                        textDecoration: "none",
                                        lineHeight: 1
                                    }}>
                                    <img src={data?.headerLogo} alt="logo"></img>
                                </RouterLink>
                                <IconButton onClick={() => setDrawer(true)}>
                                    <MenuIcon sx={{ fontSize: '2rem', color: theme.palette.primary.main }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Container>
                </Toolbar>
            </AppBar>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} data={data} />
        </>
    );
}
export default Navbar2;
